import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useTheme } from 'styled-components';
import Moment from 'moment';

import { FaClipboardList } from 'react-icons/fa';
import { IoIosInformationCircle } from 'react-icons/io';
import { FaCalendarAlt } from 'react-icons/fa';
import { FaUser } from 'react-icons/fa';
import { FaLocationArrow } from 'react-icons/fa';
import { MdLocationCity } from 'react-icons/md';
import { FaShoppingCart } from 'react-icons/fa';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import { FaReceipt } from 'react-icons/fa';

import api from '~/services/api';

import {
  Scroll,
  Container,
  Header,
  Progress,
  Grid,
  GridHeadItem,
  GridLine,
  GridItem,
} from '~/components';

import { Block, MyZone, Thumb } from './styles';

import PedidoType from '~/@types/pedido';

import { ParamsProps } from './interface';

let lang = require('moment/locale/pt-br');
Moment.locale('pt-br', lang);

const Venda: React.FC = () => {
  const { colors } = useTheme();

  const { id } = useParams<ParamsProps>();

  const [inLoad, setInLoad] = useState(false);

  const [pedido, setPedido] = useState<PedidoType | null>(null);

  useEffect(() => {
    const fetchPedido = async (cId: string) => {
      try {
        setInLoad(true);

        const response = await api.get(`pedido/${cId}`);

        const { data } = response;

        if (data) {
          setPedido(data);
        }
        setInLoad(false);
      } catch (e) {
        setInLoad(false);
      }
    };

    fetchPedido(id);
  }, [id]);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            back="/pedidos"
            title="Detalhes da pedido"
            subtitle="Veja os detalhes da pedido"
          />

          <MyZone>
            <Block>
              <h1>
                <i>
                  <FaClipboardList size={22} color={colors.IC1} />
                </i>
                <span>INFORMAÇÕES GERAIS</span>
              </h1>
              <Grid>
                <GridLine>
                  <GridItem width={200}>IDPEDIDO</GridItem>
                  <GridItem>
                    <strong>{pedido?.idpedido}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem width={200}>TIDERP</GridItem>
                  <GridItem>
                    <strong>{pedido?.tiderp}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem width={200}>STATUS</GridItem>
                  <GridItem>
                    <span
                      style={{
                        backgroundColor: pedido?.statuscor,
                        padding: 8,
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                        borderRadius: 8,
                        color: pedido?.status
                          .toLocaleLowerCase()
                          .includes('aguardando')
                          ? '#000'
                          : '#fff',
                      }}
                    >
                      {pedido?.status}
                    </span>
                  </GridItem>
                </GridLine>

                <GridLine>
                  <GridItem width={200}>CANAL</GridItem>
                  <GridItem>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {pedido?.iconecanal ? (
                        <Thumb>
                          <img src={pedido?.iconecanal} alt={pedido?.canal} />
                        </Thumb>
                      ) : null}
                      <div style={{ marginLeft: 10 }}>
                        <strong>{pedido?.canal}</strong>
                        <br />
                        <small>Conta: {pedido?.conta}</small>
                      </div>
                    </div>
                  </GridItem>
                </GridLine>
              </Grid>

              {pedido?.outrasinfos && pedido?.outrasinfos !== '' ? (
                <div className="info">
                  <i>
                    <IoIosInformationCircle size={22} color={colors.IC1} />
                  </i>
                  <p>{pedido?.outrasinfos}</p>
                </div>
              ) : null}
            </Block>

            <Block>
              <h1>
                <i>
                  <FaCalendarAlt size={22} color={colors.IC1} />
                </i>
                <span>TIMELINE</span>
              </h1>
              <Grid>
                <GridLine>
                  <GridItem width={200}>DATA DO PEDIDO</GridItem>
                  <GridItem>
                    <strong>{pedido?.dt}</strong>
                    <br />
                    <small>
                      {Moment(pedido?.dt, 'DD/MM/YYYY HH:mm').fromNow()}
                    </small>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem width={200}>LIBERAÇÃO DO ENVIO</GridItem>
                  <GridItem>
                    <strong>{pedido?.dtliberaenvio}</strong>
                    <br />
                    <small>
                      {Moment(
                        pedido?.dtlimiteenvio,
                        'DD/MM/YYYY HH:mm',
                      ).toNow()}
                    </small>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem width={200}>LIMITE DE ENVIO</GridItem>
                  <GridItem>
                    <strong>{pedido?.dtlimiteenvio}</strong>
                    <br />
                    <small>
                      {Moment(
                        pedido?.dtlimiteenvio,
                        'DD/MM/YYYY HH:mm',
                      ).toNow()}
                    </small>
                  </GridItem>
                </GridLine>
                {pedido?.dtentrega ? (
                  <GridLine>
                    <GridItem width={200}>DATA DE ENTREGA</GridItem>
                    <GridItem>
                      <strong>{pedido?.dtentrega}</strong>
                      <br />
                      <small>
                        {Moment(pedido?.dtentrega, 'DD/MM/YYYY HH:mm').toNow()}
                      </small>
                    </GridItem>
                  </GridLine>
                ) : null}
              </Grid>
            </Block>

            {pedido?.cliente.tipo === '1' ? (
              <Block>
                <h1>
                  <i>
                    <FaUser size={22} color={colors.IC1} />
                  </i>
                  <span>CLIENTE</span>
                </h1>

                <Grid>
                  <GridLine>
                    <GridItem width={200}>NOME</GridItem>
                    <GridItem>
                      <strong>
                        {pedido?.cliente.nome} {pedido?.cliente.sobrenome}
                      </strong>
                    </GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={200}>CPF</GridItem>
                    <GridItem>
                      <strong>{pedido?.cliente.cpf}</strong>
                    </GridItem>
                  </GridLine>
                  {pedido?.cliente.email ? (
                    <GridLine>
                      <GridItem width={200}>E-MAIL</GridItem>
                      <GridItem>
                        <strong>{pedido?.cliente.email}</strong>
                      </GridItem>
                    </GridLine>
                  ) : null}
                  {pedido?.cliente.sexo ? (
                    <GridLine>
                      <GridItem width={200}>SEXO</GridItem>
                      <GridItem>
                        <strong>{pedido?.cliente.sexo}</strong>
                      </GridItem>
                    </GridLine>
                  ) : null}
                  {pedido?.cliente.dtnascimento ? (
                    <GridLine>
                      <GridItem width={200}>DATA DE NASCIMENTO</GridItem>
                      <GridItem>
                        <strong>{pedido?.cliente.dtnascimento}</strong>
                      </GridItem>
                    </GridLine>
                  ) : null}
                  {pedido?.cliente.telefone ? (
                    <GridLine>
                      <GridItem width={200}>TELEFONE</GridItem>
                      <GridItem>
                        <strong>{pedido?.cliente.telefone}</strong>
                      </GridItem>
                    </GridLine>
                  ) : null}
                </Grid>
              </Block>
            ) : null}

            {pedido?.cliente.tipo === '2' ? (
              <Block>
                <h1>
                  <i>
                    <MdLocationCity size={22} color={colors.IC1} />
                  </i>
                  <span>EMPRESA</span>
                </h1>

                <Grid>
                  <GridLine>
                    <GridItem width={200}>RAZÃO SOCIAL</GridItem>
                    <GridItem>
                      <strong>{pedido?.cliente.razaosocial}</strong>
                    </GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={200}>FANTASIA</GridItem>
                    <GridItem>
                      <strong>{pedido?.cliente.nomefantasia}</strong>
                    </GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={200}>CNPJ</GridItem>
                    <GridItem>
                      <strong>{pedido?.cliente.cnpj}</strong>
                    </GridItem>
                  </GridLine>
                  {pedido?.cliente.email ? (
                    <GridLine>
                      <GridItem width={200}>E-MAIL</GridItem>
                      <GridItem>
                        <strong>{pedido?.cliente.email}</strong>
                      </GridItem>
                    </GridLine>
                  ) : null}
                  {pedido?.cliente.telefone ? (
                    <GridLine>
                      <GridItem width={200}>TELEFONE</GridItem>
                      <GridItem>
                        <strong>{pedido?.cliente.telefone}</strong>
                      </GridItem>
                    </GridLine>
                  ) : null}
                </Grid>
              </Block>
            ) : null}

            {pedido?.endereco && pedido.endereco.logradouro !== '' ? (
              <Block>
                <h1>
                  <i>
                    <FaLocationArrow size={22} color={colors.IC1} />
                  </i>
                  <span>ENDEREÇO</span>
                </h1>
                <Grid>
                  <GridLine>
                    <GridItem width={200}>LOGRADOURO</GridItem>
                    <GridItem>
                      <strong>{pedido?.endereco.logradouro}</strong>
                    </GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={200}>NÚMERO</GridItem>
                    <GridItem>
                      <strong>{pedido?.endereco.numero}</strong>
                    </GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={200}>BAIRRO</GridItem>
                    <GridItem>
                      <strong>{pedido?.endereco.bairro}</strong>
                    </GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={200}>CIDADE</GridItem>
                    <GridItem>
                      <strong>{pedido?.endereco.cidade}</strong>
                    </GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={200}>UF</GridItem>
                    <GridItem>
                      <strong>{pedido?.endereco.uf}</strong>
                    </GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={200}>CEP</GridItem>
                    <GridItem>
                      <strong>{pedido?.endereco.cep}</strong>
                    </GridItem>
                  </GridLine>
                </Grid>

                {pedido?.endereco.complemento &&
                pedido?.endereco.complemento !== '' ? (
                  <div className="info">
                    <i>
                      <IoIosInformationCircle size={22} color={colors.IC1} />
                    </i>
                    <p>{pedido?.endereco.complemento}</p>
                  </div>
                ) : null}
              </Block>
            ) : null}

            <Block>
              <h1>
                <i>
                  <FaShoppingCart size={22} color={colors.IC1} />
                </i>
                <span>ITENS</span>
              </h1>

              {pedido?.itens.length ? (
                <>
                  <Grid>
                    <GridLine>
                      <GridHeadItem title="" width={80} />
                      <GridHeadItem title="NOME" />
                      <GridHeadItem title="SKU" width={100} />
                      <GridHeadItem title="QUANTIDADE" width={80} />
                      <GridHeadItem title="UNITÁRIO" width={200} />
                    </GridLine>

                    {pedido.itens.map((item, idx) => (
                      <GridLine>
                        <GridItem width={80}>
                          <Thumb>
                            <img
                              src={item.fotoprincipal}
                              title={item.sku}
                              alt={item.sku}
                            />
                          </Thumb>
                        </GridItem>
                        <GridItem>{item.descricao}</GridItem>
                        <GridItem width={100}>{item.sku}</GridItem>
                        <GridItem width={80}>{item.qtd}</GridItem>
                        <GridItem width={200}>
                          {item.precounitformatado}
                        </GridItem>
                      </GridLine>
                    ))}
                  </Grid>
                </>
              ) : (
                <div className="info">
                  <i>
                    <IoIosInformationCircle size={22} color={colors.IC1} />
                  </i>
                  <p>Nenhum item associado ao pedido</p>
                </div>
              )}
            </Block>

            <Block>
              <h1>
                <i>
                  <FaFileInvoiceDollar size={22} color={colors.IC1} />
                </i>
                <span>INFORMAÇÕES FINANCEIRAS</span>
              </h1>

              <Grid>
                <GridLine>
                  <GridItem>
                    <div className="finance-r">SUB-TOTAL</div>
                  </GridItem>
                  <GridItem width={300}>
                    <strong>{pedido?.precoprodutosformatado}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem>
                    <div className="finance-r">DESCONTO</div>
                  </GridItem>
                  <GridItem width={300}>
                    <strong>-{pedido?.precodescontoformatado}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem>
                    <div className="finance-r">FRETE</div>
                  </GridItem>
                  <GridItem width={300}>
                    <strong>{pedido?.precofreteformatado}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem>
                    <div className="finance-r">TAXAS</div>
                  </GridItem>
                  <GridItem width={300}>
                    <strong>{pedido?.precotaxas}</strong>
                  </GridItem>
                </GridLine>
                <GridLine>
                  <GridItem>
                    <div className="finance-r" style={{ color: '#ff8904' }}>
                      TOTAL
                    </div>
                  </GridItem>
                  <GridItem width={300}>
                    <strong style={{ color: '#ff8904' }}>
                      {pedido?.precototalformatado}
                    </strong>
                  </GridItem>
                </GridLine>
              </Grid>
            </Block>

            <Block>
              <h1>
                <i>
                  <FaReceipt size={22} color={colors.IC1} />
                </i>
                <span>FATURAMENTO</span>
              </h1>

              {pedido && pedido.numnfe ? (
                <Grid>
                  <GridLine>
                    <GridItem width={300}>NÚMERO DA NFE</GridItem>
                    <GridItem>{pedido.numnfe}</GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={300}>CHAVE DA NFE</GridItem>
                    <GridItem>{pedido.chavenfe}</GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={300}>SÉRIE DA NFE</GridItem>
                    <GridItem>{pedido.serienfe}</GridItem>
                  </GridLine>
                  <GridLine>
                    <GridItem width={300}>URL DO XML</GridItem>
                    <GridItem>{pedido.urlxmlnfe}</GridItem>
                  </GridLine>
                </Grid>
              ) : (
                <div className="info">
                  <i>
                    <IoIosInformationCircle size={22} color={colors.IC1} />
                  </i>
                  <p>Pedido ainda não foi faturado</p>
                </div>
              )}
            </Block>
          </MyZone>
        </Container>
      </Scroll>
    </>
  );
};

export default Venda;
